import { TFunction } from 'i18next';

export const getLoanTypes = (t: TFunction) => [
  t('loan:conventionalInsured'),
  t('loan:conventionalUninsured'),
  t('loan:rhs'),
  t('loan:fha'),
  t('loan:va')
];

export const getLoanPurpose = (t: TFunction) => [
  t('loan:purchase'),
  t('loan:refinance'),
  t('loan:homeEqualityLoan'),
  t('loan:construction')
];